(function () {
  var PROXY = "/apps/wishlist";
  var saved = [];

  function loggedIn() {
    return document.body.getAttribute("data-customer") === "true";
  }

  function paint() {
    document.querySelectorAll("[data-save]").forEach(function (btn) {
      var on = saved.indexOf(String(btn.getAttribute("data-product-id"))) !== -1;
      btn.classList.toggle("is-saved", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
    var badge = document.querySelector("[data-save-count]");
    if (badge) badge.textContent = saved.length ? String(saved.length) : "";
    var headerLink = document.querySelector(".header-actions__saved");
    if (headerLink) headerLink.classList.toggle("is-saved", saved.length > 0);
    document.dispatchEvent(
      new CustomEvent("wishlist:changed", { detail: { saved: saved.slice() } })
    );
  }

  function refresh() {
    if (!loggedIn()) return;
    fetch(PROXY, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        saved = (data.saved || []).map(String);
        paint();
      })
      .catch(function () {});
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-save]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (!loggedIn()) {
      window.location.href =
        "/account/login?return_url=" + encodeURIComponent(location.pathname);
      return;
    }

    btn.disabled = true;
    fetch(PROXY, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productId: btn.getAttribute("data-product-id") }),
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (res.ok) {
          saved = (res.d.saved || []).map(String);
          paint();
        }
      })
      .catch(function () {})
      .finally(function () { btn.disabled = false; });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refresh);
  } else {
    refresh();
  }
})();
